// import {AuthModalVariant} from "../auth/components/auth_modal/AuthModalHeaderVariants";
// import {openAuthModal} from "../auth/state/auth_modal_slice";
import {startRegistrationFlowVariantB} from "../auth/state/registration_flow_variantB_slice";
import {useAppDispatch} from "../store/hooks";
import {gtmEventPreFormOpen} from "../tracking/google_tag_manager/gtm_event_pre_form_open";
import {UserSource} from "../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";

interface IUseHiddenPricesRegistrationHandlerParams {
    onAction: () => void;
    shouldShowPrice: boolean;
    gtmData: {
        clickText: string;
        source: string;
        vendorName: string;
        offerName: string;
        gtmSourceSection?: string;
    };
    propertyId?: number | null;
    offerId?: number | null;
}

export const useHiddenPricesRegistrationHandler = (params: IUseHiddenPricesRegistrationHandlerParams) => {
    const {onAction, shouldShowPrice, gtmData, propertyId, offerId} = params;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();

    const handleClick = () => {
        if (shouldShowPrice) {
            onAction();
            return;
        }

        gtmEventPreFormOpen(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);
        const userNeedsProfileCompletion = (userInfo && (!userInfo.phone || !userInfo.name)) ?? false;

        dispatch(
            startRegistrationFlowVariantB({
                userNeedsProfileCompletion: userNeedsProfileCompletion,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: gtmData.source,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyId ?? undefined,
                offerId: offerId ?? undefined
            })
        );
    };

    return {
        handleClick
    };
};
// import {AuthModalVariant} from "../auth/components/auth_modal/AuthModalHeaderVariants";
// import {openAuthModal} from "../auth/state/auth_modal_slice";
import {startRegistrationFlowVariantB} from "../auth/state/registration_flow_variantB_slice";
import {useAppDispatch} from "../store/hooks";
import {gtmEventPreFormOpen} from "../tracking/google_tag_manager/gtm_event_pre_form_open";
import {UserSource} from "../tracking/tracking_utils/user_source";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";

interface IUseHiddenPricesRegistrationHandlerParams {
    onAction: () => void;
    shouldShowPrice: boolean;
    gtmData: {
        clickText: string;
        source: string;
        vendorName: string;
        offerName: string;
        gtmSourceSection?: string;
    };
    propertyId?: number | null;
    offerId?: number | null;
}

export const useHiddenPricesRegistrationHandler = (params: IUseHiddenPricesRegistrationHandlerParams) => {
    const {onAction, shouldShowPrice, gtmData, propertyId, offerId} = params;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();

    const handleClick = () => {
        if (shouldShowPrice) {
            onAction();
            return;
        }

        gtmEventPreFormOpen(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);
        const userNeedsProfileCompletion = (userInfo && (!userInfo.phone || !userInfo.name)) ?? false;

        dispatch(
            startRegistrationFlowVariantB({
                userNeedsProfileCompletion: userNeedsProfileCompletion,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: gtmData.source,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyId ?? undefined,
                offerId: offerId ?? undefined
            })
        );
    };

    return {
        handleClick
    };
};
